import React from 'react';
export function DragIndicatorIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.005 7.996a2 2 0 10.006-4 2 2 0 00-.006 4zM15.006 8.005a2 2 0 10.007-4 2 2 0 00-.007 4zM8.997 13.995a2 2 0 10.006-4 2 2 0 00-.006 4zM15.006 14.01a2 2 0 10.004-4 2 2 0 00-.004 4zM8.988 19.995a2 2 0 10.006-4 2 2 0 00-.006 4zM14.989 20.004a2 2 0 10.006-4 2 2 0 00-.006 4z"
  }));
}